import styled from "styled-components";
import { ButtonTheme, BorderRadiusTheme, ColorTheme, GradientTheme } from "../../globaStyledComponents/globalStyledComponentsStyling";

interface continueBtn {
    background: string;
    isLoading: boolean;
    round?: boolean;
}

export const Btn = styled.button<continueBtn>`
    height: 48px;
    border-radius: ${(props) => props.round === false ? "12px" : "100px"};
    width: 100%;
    position: relative;
    padding: 0 32px;
    background: ${(props) => {
        if (props.background === "red") return ColorTheme.Red.color;
        if (props.background === "blue") return ColorTheme.Blue.color;
        if (props.background === "black") return ColorTheme.Black.color;
        if (props.background === "grey") return ColorTheme.Grey1.color;
        if (props.background === "gradient") return GradientTheme.Red.background;
    }};
    background: ${(props) => props.disabled && ColorTheme.Grey1.color};
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    color: ${(props) => (props.isLoading ? "transparent" : ColorTheme.White.color)};
    margin-top: auto;
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    cursor: pointer;
    user-select: none;
    transition: transform 0.08s ease;

    &:active {
        transform: scale(0.96);
    }
`;
